import { Component, OnInit } from '@angular/core';
import { User } from '../interfaces/user';
import { UserService } from '../services/user.service';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { RequestsService } from '../services/requests.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  query: string = '';
  closeResult: string;
  friendEmail: string ="";
  user: User;
  constructor(
    private userService: UserService, 
    private authenticationService: AuthenticationService,
    private router: Router,
    private modalService: NgbModal,
    private requestsServices: RequestsService
    ) { 
      this.authenticationService.getStatus().subscribe((status)=>{
        this.userService.getUserById(status.uid).valueChanges().subscribe((data:User)=>{
          this.user = data;
          this.user.friends = Object.values(this.user.friends);
        })
      })
  }
  logout(){
    this.authenticationService.logOut().then(
      ()=>{
        alert("Sesion cerrada");
        this.router.navigate(['login']);
      },
      (error)=>{
        console.log(error);
      }
    );
  }
  ngOnInit() {

  }
  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  sendRequest(){
    const request ={
      timestamp : Date.now(),
      receiver_email: this.friendEmail,
      sender: this.user.uid,
      status: 'pending'
    }
    this.requestsServices.createRequest(request).then(
      ()=>{
        alert("solicitud enviada")
      }
    ).catch((err)=>{
      alert("error")
      console.log(err)
    });
  }
}
